 <template>
  <v-dialog v-model="dialog" max-width="390">
    <v-card class="pt-6" v-if="!isLoading">
      <div class="ma-3">
        <v-lazy
          :options="{
            threshold: 0.6,
          }"
          transition="slide-x-transition"
        >
          <v-row class="ma-0 pa-0 justify-center">
            <v-icon size="62" color="primary">{{icon || 'mdi-alert-circle'}}</v-icon>
          </v-row>
        </v-lazy>

        <v-card-title
          style="word-break: normal; !important"
          class="headline justify-center text-center font-weight-bold"
          >{{ title }}</v-card-title
        >

        <v-card-text class="text-center">
          {{ info }}
        </v-card-text>
      </div>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close()">
          {{ $vuetify.lang.t("$vuetify.FECHAR") }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card class="pt-6 pl-12 pr-12" v-if="isLoading">
       <v-row class="justify-center">
            <v-progress-circular
              v-if="isLoading"
              indeterminate
              color="red"
              class="mt-10 mb-12"
            ></v-progress-circular>
          </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    close: Function,
    show: Boolean,
    title: String,
    info: String,
    dialog: Boolean,
    icon: String,
    isLoading: Boolean,
  },
};
</script>